// extracted by mini-css-extract-plugin
export default {"r_l":"_5a36bd1b47 d7d19063a9","t":"dd3082e44e"};